<template>
  <div class="logo">
    <RouterLink to="/" @click="onHome" class="logo-link">
      <img :src="logo" alt="Bhojani Parivar" width="42" height="42" class="logo-img" />
      <div class="logo-titles">
        <span class="logo-text">ભોજાણી પરિવાર</span>
        <span class="logo-subtext">કડવા પાટીદાર</span>
      </div>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { RouterLink, useRouter } from 'vue-router';
import logo from '@/assets/images/logo.png';
import { useVillagesStore } from '@/stores/villages';

const villagesStore = useVillagesStore();
const router = useRouter();

const onHome = () => {
  villagesStore.requestHome();
  router.push({ name: 'Home' });
};
</script>

<style scoped>
.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: 8px;
}

.logo-img {
  display: block;
  object-fit: contain;
  transition: transform 0.25s ease;
}

.logo-link:hover .logo-img {
  transform: scale(1.05);
}

.logo-titles {
  display: flex;
  flex-direction: column;
}

.logo-text {
  font-size: 1.2rem;
  font-weight: 800;
  color: #1e88e5;
  line-height: 1.15;
  letter-spacing: -0.2px;
}

.logo-subtext {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  line-height: 1.15;
}

@media (max-width: 600px) {
  .logo-img {
    width: 34px !important;
    height: 34px !important;
  }
  .logo-text {
    font-size: 1.02rem !important;
  }
  .logo-subtext {
    font-size: 0.68rem !important;
  }
}
</style>
